<script>
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'
import Timepicker from '../lib/time-picker.vue'

export default {
  components: { Datepicker, Timepicker },
  props: {
    showMessage: { type: Boolean, default: false },
  },
  data() {
    return {
      appointmentDate: new Date(),
      appointmentTime: '10:00',
      appointmentDuration: 30,
      appointmentSubject: 'Kennenlernen',
      appointmentMessage: '',
      dateFormat: 'yyyy-MM-dd',
      languages: lang
    }
  },
  methods: {
    submitAppointment() {
      if (this.appointmentDate && this.appointmentTime && this.appointmentSubject) {
        this.$emit('submit', {
            date: this.appointmentDate.toISOString().slice(0, 10),
            time: this.appointmentTime,
            duration: this.appointmentDuration,
            subject: this.appointmentSubject,
            message: this.appointmentMessage,
        })
      } else {
        alert('Bitte fülle alle Felder aus.')
      }
    }
  }
}
</script>

<template>
  <form>
    <div class="mb-3">
      <datepicker :inline="true" :language="languages['de']" placeholder="Datum" v-model="appointmentDate"
      :format="dateFormat" />
    </div>

    <div class="form-group mb-3">
      <timepicker v-model="appointmentTime" class="form-control"/>
    </div>

    <div class="form-group mb-3">
      <select v-model.number="appointmentDuration" class="form-control">
        <option :value="30">30 Min</option>
        <option :value="60">60 Min</option>
        <option :value="90">90 Min</option>
      </select>
    </div>

    <div class="form-group mb-3">
      <input 
        type="text" 
        v-model="appointmentSubject" 
        class="form-control" 
        placeholder="Thema"
      />
    </div>

    <div v-if="showMessage" class="form-group mb-3">
      <input
        type="text"
        v-model="appointmentMessage"
        class="form-control"
        placeholder="Nachricht (optional)"
      />
    </div>

    <div class="d-flex gap-2">
      <button @click.prevent="$emit('cancel')" class="btn btn-secondary">
        Abbrechen
      </button>
      <button @click.prevent="submitAppointment" class="btn btn-primary">
         Weiter ...
      </button>
    </div>

  </form>
</template>
